import { useContext } from 'react';

import { LicensesContext } from './licenses-context';

export const useIsLicensesOnline = (): boolean => {
  const state = useContext(LicensesContext);

  if (!state) {
    throw new Error(
      'useIsLicensesOnline must be used within a LicenseConsumer',
    );
  }

  return state.isOnline;
};
